import styles from './Bubbles.module.scss'
import React from 'react'

export const Bubbles = ({
  btnsOptions,
  handleChange,
  selectedBubble,
  setSelectedBubble
}) => {
  const handleClick = (value) => {
    setSelectedBubble(value)
    handleChange(value)
  }

  return (
    <div className={styles.root} data-testid="bubbles-root">
      {btnsOptions.map((item, idx) => (
        <div
          key={idx}
          className={`${styles.bubble} ${item.value === selectedBubble ? styles.active : ''}`}
          data-testid="bubbles-item"
          onClick={() => handleClick(item.value)}
        >
          {item.label}
        </div>
      ))}
    </div>
  )
}
